import React from "react";
import EarlyAccessButton from "../EarlyAccessButton";
import styles from "./styles.module.scss";

interface DeepSearchSectionProps {
  onDownloadClick: () => void;
}

/**
 * DeepSearchSection 组件
 * 展示自动化多源研究生成可追溯报告的功能
 */
const DeepSearchSection = ({ onDownloadClick }: DeepSearchSectionProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {/* 左侧部分 - 文本内容 */}
        <div className={styles.textContentSection}>
          <div className={styles.textContentInner}>
            <h2 className={styles.mainTitle}>
              Fellou is for <span className={styles.highlight}>Insight.</span>
            </h2>

            <div className={styles.searchComparisonText}>
              <div className={styles.searchComparisonLine}>Stop paying for premium reports. Get rich, in-</div>
              <div className={styles.searchComparisonLine}>depth answers on any topic, all for free.</div>
            </div>

            <EarlyAccessButton onClick={onDownloadClick} />
          </div>
        </div>

        {/* 右侧部分 - 视频展示（替代动画演示） */}
        <div className={styles.videoSection}>
          <div className={styles.videoContainer}>
            <video autoPlay muted loop playsInline className={styles.videoElement}>
              <source
                src="https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/Website+main+page+animation/Deep+search.webm"
                type="video/webm"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeepSearchSection;
